export const LOCALES = [
  {
    code: 'en_US',
    Value: 'English (US)',
  },
  {
    code: 'fr_FR',
    Value: 'French',
  },
  {
    code: 'de_DE',
    Value: 'German',
  },
  {
    code: 'es_ES',
    Value: 'Spanish',
  },
  {
    code: 'it_IT',
    Value: 'Italian',
  },
  {
    code: 'ja_JP',
    Value: 'Japanese',
  },
  {
    code: 'ko_KR',
    Value: 'Korean',
  },
  {
    code: 'zh_TW',
    Value: 'Traditional Chinese',
  },
  {
    code: 'zh_CN',
    Value: 'Simplified Chinese',
  },
  {
    code: 'pt_BR',
    Value: 'Brazilian Portuguese',
  },
  {
    code: 'ru_RU',
    Value: 'Russian',
  },
  {
    code: 'tr_TR',
    Value: 'Turkish',
  },
]

export const REPAIR_TYPES = [
  {
    code: 'SVNR',
    label: 'Service Non-Repair',
  },
  {
    code: 'CRBR',
    label: 'Carry-In Return Before Replace',
  },
  {
    code: 'DION',
    label: 'Onsite Service Direct',
  },
  {
    code: 'MINS',
    label: 'Mail-In Return to Service Location',
  },
  {
    code: 'MINC',
    label: 'Mail-In Return to Customer',
  },
  {
    code: 'CINR',
    label: 'Carry-In Non-Replenishment',
  },
  {
    code: 'INON',
    label: 'Onsite Service Indirect',
  },
  {
    code: 'CIN',
    label: 'Carry-In',
  },
  {
    code: 'WUMS',
    label: 'Whole Unit Mail-In Return to Service Location',
  },
  {
    code: 'WUMC',
    label: 'Whole Unit Mail-In Return to Customer',
  },
  {
    code: 'OSR',
    label: 'Onsite Service Facilitated',
  },
  {
    code: 'OSCR',
    label: 'Onsite Service Pickup',
  },
]

export const COVERAGE_STATUSES = [
  {
    code: 'LI',
    Value: 'Apple Limited Warranty',
  },
  {
    code: 'LP',
    Value: 'Apple Limited Warranty',
  },
  {
    code: 'RP',
    Value: 'Repeat Service',
  },
  {
    code: 'IR',
    Value: 'Internal Repairs',
  },
  {
    code: 'LS',
    Value: 'Lost Shipments (Coverage)',
  },
  {
    code: 'CC',
    Value: 'Custom Bid Contracts',
  },
  {
    code: 'CS',
    Value: 'Customer Satisfaction (CS) Code',
  },
  {
    code: 'DO',
    Value: 'DOA Coverage',
  },
  {
    code: 'MU',
    Value: 'Missing Upon 1st Use',
  },
  {
    code: 'OO',
    Value: 'Out Of Warranty (No Coverage)',
  },
  {
    code: 'PA',
    Value: 'AppleCare Parts Agreement',
  },
  {
    code: 'QP',
    Value: 'Quality Program',
  },
  {
    code: 'RE',
    Value: 'Repeat Service',
  },
  {
    code: 'G9',
    Value: 'Pending Coverage Check',
  },
  {
    code: 'RA',
    Value: 'AppleCare Repair Agreement',
  },
  {
    code: 'PP',
    Value: 'AppleCare Protection Plan',
  },
  {
    code: 'C1',
    Value: 'AppleCare Protection Plan',
  },
  {
    code: 'C2',
    Value: 'AppleCare Parts Agreement',
  },
  {
    code: 'C3',
    Value: 'AppleCare Repair Agreement',
  },
  {
    code: 'C4',
    Value: 'Custom Bid Contracts',
  },
  {
    code: 'C5',
    Value: 'Extended Contract',
  },
  {
    code: 'TC',
    Value: 'Edu/Govt Warranty (Australia)',
  },
  {
    code: 'PT',
    Value: 'Additional Part Coverage',
  },
  {
    code: 'EC',
    Value: 'Additional Service Coverage',
  },
  {
    code: 'CL',
    Value: 'Consumer Law Coverage',
  },
  {
    code: 'CP',
    Value: 'Consumer Law Coverage',
  },
  {
    code: 'CI',
    Value: 'Consumer Law Repeat Coverage',
  },
  {
    code: 'CW',
    Value: 'Consumer Law Repeat Coverage',
  },
  {
    code: 'VW',
    Value: 'Variable Warranty',
  },
  {
    code: 'VP',
    Value: 'Variable Warranty',
  },
  {
    code: 'RI',
    Value: 'Variable Warranty Repeat',
  },
  {
    code: 'RW',
    Value: 'Variable Warranty Repeat',
  },
  {
    code: 'LN',
    Value: 'Loaner - No Warranty',
  },
]

export const REPAIR_CLASSIFICATIONS = [
  {
    code: 'SINGLE',
    label: 'Single submission - Customer requests one repair',
  },
  {
    code: 'BULK',
    label: 'Bulk submission - Customer requests multiple repairs',
  },
  {
    code: 'NEEDS_EXTRA_UNDERSTANDING',
    label:
      'Needs extra understanding - Customer requests repairs for a large number of devices that may not belong to them',
  },
]

export const REPAIR_NOTE_TYPES = [
  {
    code: 'CUSTOMER_INTAKE_NOTES',
    label: 'Customer intake notes',
  },
  {
    code: 'TECHNICIAN',
    label: 'Technician notes',
  },
  {
    code: 'HOLD_REVIEW',
    label: 'Notes for review',
  },
  {
    code: 'REVIEW_RESULT',
    label: 'Notes indicating results for review hold',
  },
  {
    code: 'REP_STS',
    label: 'Repair status notes',
  },
  {
    code: 'RC_NOTE',
    label: 'Repair Center notes',
  },
]

export const CONSUMER_LAWS = [
  {
    code: 'RFD',
    label: 'Refund',
  },
  {
    code: 'RPL',
    label: 'Replace',
  },
  {
    code: 'SVC',
    label: 'Service',
  },
  {
    code: 'OPT_IN',
    label: 'Customer has opted in for Consumer Law coverage',
  },
  {
    code: 'OPT_OUT',
    label: 'Customer has opted out of Consumer Law coverage',
  },
]

export const REPRODUCIBILITY = [
  {
    code: 'A',
    label: 'Not Applicable',
  },
  {
    code: 'B',
    label: 'Continuous',
  },
  {
    code: 'C',
    label: 'Intermittent',
  },
  {
    code: 'D',
    label: 'Fails After Warm Up',
  },
  {
    code: 'E',
    label: 'Environmental',
  },
  {
    code: 'F',
    label: 'Configuration: Peripheral',
  },
  {
    code: 'G',
    label: 'Damaged',
  },
  {
    code: 'H',
    label: 'Screening Request',
  },
]

export const REPAIR_STATUSES = [
  {
    code: 'ADMH',
    label: 'Hold - Your Request for Apple Review is Pending',
  },
  {
    code: 'COVM',
    label: 'Hold - Coverage Verification and Matchup',
  },
  {
    code: 'DELR',
    label: 'Delete Repair',
  },
  {
    code: 'DCLM',
    label: 'Duplicate Claim for Unit Only One Labor',
  },
  {
    code: 'GX01',
    label: 'Pending Local Authorization',
  },
  {
    code: 'GX02',
    label: 'Declined - Rejected by Local Approver',
  },
  {
    code: 'GX03',
    label: 'Saved for Later',
  },
  {
    code: 'GX05',
    label: 'Pending Apple Review',
  },
  {
    code: 'GX06',
    label: 'Approved by Local Approver',
  },
  {
    code: 'GX07',
    label: 'Approved by Apple',
  },
  {
    code: 'GX08',
    label: 'Declined - Rejected by Apple',
  },
  {
    code: 'IFES',
    label: 'Warranty Claim Review Hold',
  },
  {
    code: 'IFSA',
    label: 'Warranty Claim Approved',
  },
  {
    code: 'IFSR',
    label: 'Warranty Claim Denied',
  },
  {
    code: 'MRPR',
    label: 'Hold - Multiple repairs for the same unit',
  },
  {
    code: 'NEWO',
    label: 'New',
  },
  {
    code: 'SACM',
    label: 'Closed and Completed by the System',
  },
  {
    code: 'SCNC',
    label: 'Declined - Repair Cancelled',
  },
  {
    code: 'SPCM',
    label: 'Repair Marked Complete',
  },
  {
    code: 'SCOM',
    label: 'Closed and Completed',
  },
  {
    code: 'POPH',
    label: 'Hold - Proof of Coverage Review',
  },
  {
    code: 'RFPU',
    label: 'Ready for Pickup',
  },
  {
    code: 'POCR',
    label: 'Credit Review - Contact Accounts Receivable',
  },
  {
    code: 'RLSD',
    label: 'Repair released from processing',
  },
]

export const COVERAGE_OPTIONS = [
  {
    code: 'BATTERY',
    label: 'Billable battery repair',
  },
  {
    code: 'DISPLAY',
    label: 'Billable display repair',
  },
  {
    code: 'VMI_YELLOW',
    label: 'VMI Yellow, service price',
  },
  {
    code: 'APPLECARE_PLUS',
    label: 'AppleCare+ covered incident',
  },
  {
    code: 'VMI_RED',
    label: 'VMI Red, full price',
  },
  {
    code: 'VMI_GREEN',
    label: 'VMI Green',
  },
]

export const LOANER_RETURN_DISPOSITIONS = [
  {
    code: 'LRFR',
    Value: 'Recycle Loaner - Place back in stock',
  },
  {
    code: 'LVFN',
    Value: 'Component Check Failed - Abandoned',
  },
  {
    code: 'LEXP',
    Value: 'Loaner Expired',
  },
  {
    code: 'LABN',
    Value: 'Repair Abandoned - No charge, iPhone return',
  },
  {
    code: 'LRTN',
    Value: 'Return Loaner - No damage, no charge',
  },
  {
    code: 'LABS',
    Value: 'Non-Repairable Damage - Return, no charge',
  },
  {
    code: 'LRDD',
    Value: 'Return Loaner - Display damage',
  },
  {
    code: 'DOA',
    Value: 'Loaner Dead on Arrival - Return, no charge',
  },
  {
    code: 'LOST',
    Value: 'Loaner Lost - Charge, no return',
  },
  {
    code: 'LVFU',
    Value: 'Component Check Failed - Charge',
  },
  {
    code: 'LABE',
    Value: 'Return Loaner - Repairable Damage',
  },
]

export const REPAIR_OUTCOME_REASONS = [
  {
    code: 'HOLD',
    Value: 'Denotes that repair is created and is put on hold',
  },
  {
    code: 'STOP',
    Value: 'Denotes that repair cannot be created',
  },
  {
    code: 'MESSAGE',
    Value: 'Denotes that repair is created',
  },
  {
    code: 'REPAIR_TYPE',
    Value: 'Eligible repair types',
  },
  {
    code: 'WARNING',
    Value: 'Additional coverage details',
  },
]

export const GSX_SERVICE_NON_REPAIR_TYPES = [
  {
    Key: 'NTF',
    Value: 'No Trouble Found',
  },
  {
    Key: 'SRC',
    Value: 'Screening',
  },
  {
    Key: 'LUA',
    Value: 'Loaner Unavailable',
  },
]

export const GSX_ARTICLE_TYPES = [
  {
    code: 'SERVICE_NEWS',
    label: 'Service News',
  },
  {
    code: 'SERVICE_DISK_IMAGE',
    label: 'Service Disk Image',
  },
  {
    code: 'OPERATIONAL_PROCEDURE',
    label: 'Operational Procedures',
  },
  {
    code: 'RETAIL_PROCEDURE',
    label: 'Retail Procedure',
  },
  {
    code: 'SERVICE_VIDEOS',
    label: 'Service Videos',
  },
  {
    code: 'TECHNICAL_PROCEDURE',
    label: 'Technical Procedures',
  },
]

export const ORDER_STATUS_GROUP_CODE = [
  {
    code: 'ALL',
    label: 'All',
  },
  {
    code: 'CLOSED',
    label: 'Closed',
  },
  {
    code: 'OPEN',
    label: 'Open',
  },
]

export const ORDER_TYPE_CODE = [
  {
    code: 'INCREASE',
    label: 'Increase',
  },
  {
    code: 'DECREASE',
    label: 'Decrease',
  },
]
